'use client';

import { usePathname } from 'next/navigation';

const hideFooterPaths = [
  { path: '/quote', exact: false },
  { path: '/cars/deal-confirmation', exact: false },
  { path: '/booking-confirmation', exact: false },
];

export const useHideFooter = (): boolean => {
  const pathname = usePathname();

  return hideFooterPaths.some(({ path, exact }) => {
    if (exact) {
      return pathname === path || pathname === `${path}/`;
    } else {
      return pathname === path || pathname?.startsWith(`${path}/`);
    }
  });
}; 